import React from "react";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { Box, Typography } from "@mui/material";

const TranscriptModal = ({ isOpen, onClose, ticket, messages, title = "Transcript" }) => {
    if (!isOpen) return null;

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const options = {
            weekday: "short",
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: "short",
        };
        return date.toLocaleDateString("en-US", options);
    };

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        const transcriptText = `
Ticket transcript:
-------------------------------------------
Ticket ID: #${ticket?._id?.slice(-6) || "N/A"}
Subject: ${ticket?.subject || "N/A"}
Status: ${ticket?.status || "N/A"}
Priority: ${ticket?.priority || "N/A"}

-------------------------------------------
Customer Information
Name: ${ticket?.customerName || "N/A"}
Email: ${ticket?.customerEmail || "N/A"}

-------------------------------------------
Untrimmed
${messages
                .filter((m) => !m.isPrivate && m.type === "user" && m.un_trimmed_content)
                .map(
                    (m) =>
                        `${m.sender?.full_name || m.sender_name || m.sender || "Guest"} (${formatDate(
                            m.createdAt || m.created_at
                        )})\n${m.un_trimmed_content || m.message || m.content}\n`
                )
                .join("\n-------------------------------------------\n")}
    `;
        const element = document.createElement("a");
        const file = new Blob([transcriptText], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = `transcript-${ticket?._id?.slice(-6)}.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <>
            <div className="overlay" style={{ zIndex: 10000 }} onClick={onClose} />
            <div
                className="Team-PopUp-Container"
                style={{
                    zIndex: 10001,
                    width: "424px",
                    maxWidth: "min(90vw, 424px)",
                    height: "504px",
                    maxHeight: "calc(100vh - 32px)",
                    padding: "24px 32px",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    boxSizing: "border-box",
                }}
            >
                <div className="Team-PopUp-Header" style={{ marginBottom: "8px", flexShrink: 0 }}>
                    <p className="PopUp-Text01">{title}</p>
                    <p className="PopUp-Text02" onClick={onClose} style={{ cursor: "pointer" }}>
                        <Close />
                    </p>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "8px",
                        flexShrink: 0,
                        minWidth: 0,
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 10H4.92133C5.17363 10 5.40431 10.1424 5.51733 10.368L5.81533 10.9647C5.92828 11.1907 6.15932 11.3335 6.412 11.3333H9.58733C9.84002 11.3335 10.0711 11.1907 10.184 10.9647L10.482 10.3687C10.595 10.1426 10.826 9.99988 11.0787 10H14" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M12 2C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12Z" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.6663 6.62924L5.33301 6.62923" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#405261",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: 0,
                            flex: 1,
                        }}
                    >
                        {ticket?.subject}
                    </Typography>
                </div>

                <Box
                    sx={{
                        background: "#F9FAFA",
                        borderRadius: "8px",
                        padding: "16px",
                        width: "100%",
                        flex: 1,
                        minHeight: 0,
                        maxHeight: "328px",
                        boxSizing: "border-box",
                        overflowX: "hidden",
                        overflowY: "auto",
                        border: "1px solid #E9ECEF",
                        "&::-webkit-scrollbar": {
                            width: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#D5DCE1",
                            borderRadius: "10px",
                        },
                    }}
                >
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>Ticket transcript:</Typography>
                    <Box
                        sx={{
                            borderBottom: "1px dashed #D5DCE1",
                            mb: 2,
                        }}
                    />

                    <Box sx={{ mb: 3, minWidth: 0 }}>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, wordBreak: "break-word" }}>
                            Ticket ID: #{ticket?._id?.slice(-6) || "N/A"}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, wordBreak: "break-word" }}>
                            Subject: {ticket?.subject || "N/A"}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, textTransform: "capitalize", wordBreak: "break-word" }}>
                            Status: {ticket?.status || "N/A"}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, textTransform: "capitalize", wordBreak: "break-word" }}>
                            Priority: {ticket?.priority || "N/A"}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            borderBottom: "1px dashed #D5DCE1",
                            mb: 2,
                        }}
                    />
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>Customer Information</Typography>
                    <Box sx={{ mb: 3, minWidth: 0 }}>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, wordBreak: "break-word" }}>
                            Name: {ticket?.customerName || "N/A"}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", mb: 0.5, wordBreak: "break-word" }}>
                            Email: {ticket?.customerEmail || "N/A"}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            borderBottom: "1px dashed #D5DCE1",
                            mb: 2,
                        }}
                    />
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>Untrimmed Messages</Typography>

                    {messages.filter((m) => !m.isPrivate && m.type === "user" && m.un_trimmed_content).length > 0 ? (
                        messages
                            .filter((m) => !m.isPrivate && m.type === "user" && m.un_trimmed_content)
                            .map((message, index, filtered) => (
                                <Box key={message._id || index} sx={{ mb: 2, minWidth: 0 }}>
                                    <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#405261", mb: 0.5, wordBreak: "break-word" }}>
                                        {message.sender?.full_name || message.sender_name || message.sender || "Guest"}{" "}
                                        ({formatDate(message.createdAt || message.created_at)})
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: "13px",
                                            color: "#061522",
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                        }}
                                    >
                                        {message.un_trimmed_content || message.content || message.message}
                                    </Typography>
                                    {index < filtered.length - 1 && (
                                        <Box
                                            sx={{
                                                borderBottom: "1px dashed #E9ECEF",
                                                my: 1,
                                            }}
                                        />
                                    )}
                                </Box>
                            ))
                    ) : (
                        <Typography sx={{ fontSize: "14px", color: "#6C757D", textAlign: "center", mt: 4 }}>
                            No transcript available
                        </Typography>
                    )}
                </Box>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "8px",
                        marginTop: "24px",
                        flexShrink: 0,
                    }}
                >
                    <button
                        className="buttonstyle-Cancel"
                        onClick={handlePrint}
                        style={{ width: "72px", height: "40px", margin: "unset" }}
                    >
                        Print
                    </button>
                    <button
                        className="buttonstyle-Ticket"
                        onClick={handleDownload}
                        style={{ width: "136px", height: "40px", margin: "unset" }}
                    >
                        Download TXT
                    </button>
                </div>
            </div>
        </>
    );
};

export default TranscriptModal;
